"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableTypes = {
    DataAnalytic: "DataTables::DataAnalytic",
    Survey: "DataTables::Survey",
    EventReport: "DataTables::EventReport",
    Reporting: "DataTables::Reporting",
};
exports.default = TableTypes;
//# sourceMappingURL=TableTypes.js.map